import { EntityValidator, EntityValidatorCreator, EntityValidationResult } from "../lib/entities/validation";

type CompanyValue = WtdModels.Partial<WtdModels.CompanyValue, "id" | "description">;

export const companyValueValidatorCreator: EntityValidatorCreator<CompanyValue, number> = maxLength => {
  return function companyValueValidator(companyValue) {
    const result: EntityValidationResult<CompanyValue> = {};
    if (!companyValue.description) {
      result.description = "required";
    } else if (companyValue.description.length > maxLength) {
      result.description = "too_long";
    }
    return result;
  };
};

type CompanyMembershipSection = WtdModels.Partial<WtdModels.CompanyMembershipSection, "id" | "name">;

export const membershipSectionValidator: EntityValidator<CompanyMembershipSection> = section => {
  const result: EntityValidationResult<CompanyMembershipSection> = {};
  if (!section.name) {
    result.name = "required";
  } else if (section.name.length > 30) {
    result.name = "too_long";
  }
  return result;
};



// WEBPACK FOOTER //
// ./frontend/src/companies/validation.ts